import { useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SiteMetaLoader() {
  useEffect(() => {
    const loadSiteSettings = async () => {
      try {
        const response = await axios.get(`${API_URL}/settings/site`);
        const settings = response.data;
        
        // Update page title
        if (settings.title) {
          document.getElementById('page-title').textContent = settings.title;
          document.getElementById('og-title')?.setAttribute('content', settings.title);
          document.getElementById('twitter-title')?.setAttribute('content', settings.title);
        }
        
        // Update description
        if (settings.description) {
          document.getElementById('meta-description')?.setAttribute('content', settings.description);
          document.getElementById('og-description')?.setAttribute('content', settings.description);
          document.getElementById('twitter-description')?.setAttribute('content', settings.description);
        }
        
        // Update keywords
        if (settings.keywords) {
          document.getElementById('meta-keywords')?.setAttribute('content', settings.keywords);
        }
        
        // Update theme color
        if (settings.theme_color) {
          document.getElementById('theme-color-meta')?.setAttribute('content', settings.theme_color);
        }
        
        // Update favicon
        if (settings.favicon_url) {
          const faviconUrl = settings.favicon_url.startsWith('http') 
            ? settings.favicon_url 
            : `${process.env.REACT_APP_BACKEND_URL}${settings.favicon_url}`;
          
          document.getElementById('favicon-link')?.setAttribute('href', faviconUrl);
          document.getElementById('apple-touch-icon')?.setAttribute('href', faviconUrl);
        }
        
        // Update OG image
        if (settings.og_image_url) {
          const ogImageUrl = settings.og_image_url.startsWith('http')
            ? settings.og_image_url
            : `${process.env.REACT_APP_BACKEND_URL}${settings.og_image_url}`;
          
          document.getElementById('og-image')?.setAttribute('content', ogImageUrl);
          document.getElementById('twitter-image')?.setAttribute('content', ogImageUrl);
        }
        
        // Update OG type
        if (settings.og_type) {
          document.getElementById('og-type')?.setAttribute('content', settings.og_type);
        }
        
        // Update Twitter card type
        if (settings.twitter_card) {
          document.getElementById('twitter-card')?.setAttribute('content', settings.twitter_card);
        }
        
        // Set current URL for OG
        document.getElementById('og-url')?.setAttribute('content', window.location.origin);
        
      } catch (error) {
        // Error silenced: 'Error loading site settings:', error);
      }
    };
    
    loadSiteSettings();
  }, []);
  
  return null; // This component doesn't render anything
}
